import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
@Component({
  standalone: false,
  selector: 'mm-totals',
  templateUrl: './table-row-totals.component.html',
  styleUrls: ['./table-row-totals.component.scss']
})
export class TotalsComponent implements OnInit, OnChanges {
  @Input() gridApi: GridApi | undefined | null;
  @Input() sharesSelected: string | null;
  @Input() totalValue: string | null;
  @Input() isReviewPage: boolean | null;
  constructor() {}

  ngOnInit(): void {
  }

  ngOnChanges() {
  }
}